import { render } from "./IsLockBadge.vue?vue&type=template&id=866310b2"
import script from "./IsLockBadge.vue?vue&type=script&lang=js"
export * from "./IsLockBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__